"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBReformSellPositive = function SvgBReformSellPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M22.323 132.541a5.363 5.363 0 01-5.299-5.352L16.89 74.76a1.46 1.46 0 00-1.47-1.459l-11.196.034a3.61 3.61 0 01-2.55-6.167c9.982-9.858 28.44-28.203 44.924-44.58L67.675 1.648a5.74 5.74 0 018.098.023l49.641 49.91a2.087 2.087 0 11-2.96 2.94L72.822 4.617a1.565 1.565 0 00-2.205-.038l-21.079 20.97C33.585 41.4 15.777 59.095 5.64 69.16l9.804-.03a5.642 5.642 0 015.655 5.622l.101 52.427c.004.659.539 1.19 1.197 1.19l39.479-.104a1.28 1.28 0 001.275-1.279l-.021-6.373a8.591 8.591 0 016.477-8.355l-.06-21.312a2.087 2.087 0 114.175-.01l.062 23.149a2.087 2.087 0 01-2.082 2.092 4.397 4.397 0 00-4.397 4.425l.02 6.367a5.44 5.44 0 01-5.438 5.47l-39.48.112-.083-.009z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M48.5 106.135a2.087 2.087 0 01-1.834-2.982l23.263-49.271a2.088 2.088 0 013.778.003l23.222 49.15a2.087 2.087 0 01-1.881 2.973l-9.741.025a2.087 2.087 0 01-.011-4.175l6.422-.02-19.9-42.176-19.983 42.287 18.564-.045a2.087 2.087 0 11.01 4.175l-21.868.057-.042-.001z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M28.782 65.826a2.087 2.087 0 01-1.44-3.56l41.457-41.675a3.917 3.917 0 015.566-.014l40.527 40.296a2.089 2.089 0 01-2.946 2.961l-40.35-40.126-41.3 41.505c-.4.401-.947.623-1.514.613zM75.092 132.398a2.087 2.087 0 01.031-4.174l45.999-.116a1.203 1.203 0 001.19-1.203l-.05-13.916a2.087 2.087 0 114.175-.011l.05 13.916a5.37 5.37 0 01-5.355 5.382l-45.998.123-.042-.001z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M124.138 100.393a8.793 8.793 0 01-5.894-2.336 2.087 2.087 0 012.836-3.047 4.765 4.765 0 003.228 1.212c2.394-.007 4.343-1.678 4.337-3.723-.003-2.206-2.283-3.519-4.534-3.718a11.13 11.13 0 01-2.96-.623c-3.33-1.33-5.404-4.101-5.44-7.233-.014-4.397 3.805-7.942 8.488-7.957a8.849 8.849 0 015.98 2.233 2.088 2.088 0 01-2.796 3.103 4.689 4.689 0 00-3.173-1.162c-2.394.007-4.343 1.678-4.337 3.723.006 2.046 2.136 3.155 2.786 3.417a7.096 7.096 0 001.747.336c4.864.391 8.361 3.695 8.372 7.855.015 4.363-3.804 7.907-8.487 7.923l-.153-.003z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M124.328 113.407a2.087 2.087 0 01-2.05-2.081l-.04-12.935a2.087 2.087 0 114.175-.01l.039 12.934a2.087 2.087 0 01-2.082 2.093h-.042zM124.218 75.487a2.087 2.087 0 01-2.051-2.082l-.054-20.06a2.087 2.087 0 114.175-.01l.054 20.06a2.087 2.087 0 01-2.082 2.092h-.042z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M107.929 115.417a2.087 2.087 0 01-2.051-2.081l-.116-43.57a2.087 2.087 0 01.61-1.479l16.352-16.413a2.087 2.087 0 112.96 2.94l-15.742 15.831.105 40.6 28.625-.078-.112-40.6-6.039-6.005a2.089 2.089 0 012.946-2.961l6.654 6.614c.39.394.61.925.615 1.48l.116 43.549a2.087 2.087 0 01-2.082 2.092l-32.8.089-.041-.008z",
    fill: "#285"
  })));
};

var _default = SvgBReformSellPositive;
exports["default"] = _default;